module.exports = __webpack_public_path__ + "img/pay_icon2.f6e7c569.png";